<template lang="">
  <div>
    <el-dialog
      title="波次"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="160px"
        :rules="rules"
        :disabled="!!form.waveCode"
        class="waveform"
      >
        <el-form-item label="发货单类型" prop="deliveryType">
          <el-radio-group v-model="form.deliveryType" @input="clearValid">
            <el-radio-button :label="0" :disabled="true"
              >FBA发货</el-radio-button
            >
            <el-radio-button :label="1" :disabled="true"
              >大包发货</el-radio-button
            >
            <el-radio-button :label="2">小包发货</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="单多品"
          v-if="form.deliveryType == 2"
          prop="singleProduct"
        >
          <el-radio-group v-model="form.singleProduct">
            <el-radio-button :label="1">单品</el-radio-button>
            <el-radio-button :label="0">多品</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="创建截止时间" prop="conditionEndTime">
          <el-date-picker
            v-model="form.conditionEndTime"
            type="datetime"
            placeholder="截止时间"
            default-time="15:00:00"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发货单上限" prop="deliveryTaskLimit">
          <el-input
            v-model="form.deliveryTaskLimit"
            placeholder="请输入，为空则按全部处理"
          ></el-input>
        </el-form-item>
        <el-form-item label="发货单商品数量" prop="pickTaskDeliveryProductLimit" v-if="form.deliveryType == 2 && form.singleProduct == 0">
          <el-input
            v-model="form.pickTaskDeliveryProductLimit"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务发货单数"
          prop="pickTaskLimit"
          v-if="form.singleProduct != 1"
        >
          <el-input
            v-model="form.pickTaskLimit"
            placeholder="请输入"
          ></el-input>
          <br />
          <span>每个拣货任务包含的最大发货单数，需小于等于分拣车的框数</span>
        </el-form-item>
        <!-- <el-form-item label="库区" prop="regionCodeList">
          <el-select v-model=form.regionCodeList multiple></el-select>
        </el-form-item> -->
        <el-form-item label="物流" prop="intForwarderConfigIdList">
          <el-select
            v-model="form.intForwarderConfigIdList"
            @visible-change="getForwarder"
            ref="forwarderRef"
            multiple
          >
            <el-option
              v-for="i in forwarder"
              :label="`${i.forwarder}-${i.shippingType}${
                i.totalAmount ? `(${i.totalAmount})` : ''
              }`"
              :value="i.intForwarderConfigId"
              :key="i.intForwarderConfigId"
              :disabled="!i.totalAmount"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="客户ID"
          v-if="form.deliveryType == 2"
          prop="customerId"
        >
          <el-input v-model="form.customerId" placeholder="请输入"></el-input>
          <el-button
            type="primary"
            style="margin-left: 10px"
            @click="searchCustomer"
            :disabled="!form.customerId"
            >查询</el-button
          >
          <template v-if="customerInfo">
            <br />
            <span>客户名称：{{ customerInfo.customerName }}</span>
            <br />
            <span
              >可拣货发货单数：{{ customerInfo.deliveryTaskTotalAmount }}</span
            >
          </template>
        </el-form-item>
        <el-form-item label="tiktok分组" required prop="tiktokGroup">
          <el-radio-group v-model="form.tiktokGroup">
            <el-radio :label="0">合并拣货</el-radio>
            <el-radio :label="1">分开拣货</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 单品小包 -->
        <template v-if="form.singleProduct === 1 && isHzOrXz">
          <el-form-item label="分组限定" required prop="groupType">
            <el-radio-group v-model="form.groupType">
              <el-radio :label="0">无需分组</el-radio>
              <el-radio :label="1">同批次 
                <el-tooltip class="item" effect="dark" content="按照同批次分组生成爆品拣货任务，在小件单品批量打包页面执行打包" placement="top">
                  <span class="el-icon-question"></span>
                </el-tooltip>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="分组最小发货单数量" required v-if="form.groupType === 1">
            <el-input-number :min="1" :controls="false" :step="1" v-model="form.explosiveProductGroupMin"></el-input-number>
          </el-form-item>
        </template>

<el-form-item label="客户店铺名称">
  <el-input v-model="form.customerShopName" placeholder="请输入"></el-input>
</el-form-item>
<el-form-item label="指定发货单">
  <el-input type="textarea" v-model="form.conditionDeliveryTaskCodes" placeholder="请输入"></el-input>
</el-form-item>
</el-form>
<div style="margin-bottom: 10px" v-if="!form.waveCode">
  <span>匹配发货单数(总数)
    {{
    checkDeliveryNumData
    ? `${checkDeliveryNumData.matchTotal}(${checkDeliveryNumData.total})`
    : "-"
    }}</span>
  <el-button type="primary" @click="checkDeliveryNum" style="margin-left: 10px">查询</el-button>
</div>
<div v-if="!form.waveCode">
  <el-button @click="dialogVisible = false">取消</el-button>
  <el-button type="primary" @click="submit">确定</el-button>
</div>
<div v-else>
  <!-- <el-button type="danger" @click="toCancelWave">撤回</el-button> -->
</div>
</el-dialog>
</div>
</template>
<script>
import {
  waveMatchAnalysis,
  waveCreate,
  waveForwarder,
  waveDeliveryTaskAmount,
  waveCancel,
} from "@/apis/outStock";
import moment from "moment";
export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        deliveryType: 2,
        singleProduct: 1,
        pickTaskLimit:
          this.$store.getters.getWareCode == "1772139957530296320" ? 16 : 20,
        pickTaskDeliveryProductLimit: 20,
        groupType: 0,
        tiktokGroup: 0,
        explosiveProductGroupMin: 10,
      },
      forwarder: [],
      rules: {
        deliveryType: [
          { required: true, message: "请选择发货单类型", trigger: "change" },
        ],
        singleProduct: [
          { required: true, message: "请选择单多品", trigger: "change" },
        ],
        conditionEndTime: [
          { required: true, message: "请选择截止创建时间", trigger: "blur" },
        ],
        explosiveProductGroupMin: [
          {
            required: true,
            message: "请填写分组最小发货单数量",
            trigger: "blur",
          },
        ],
        pickTaskLimit: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入发货单任务数"));
              } else if (isNaN(value)) {
                callback(new Error("请输入数字"));
              } else if (!Number.isInteger(Number(value))) {
                callback(new Error("请输入整数"));
              } else if (value > 20 || value < 1) {
                callback(new Error("单批次组数上限范围1~20"));
              } else {
                callback();
              }
            },
          },
        ],
        regionCodeList: [
          { required: true, message: "请选择库区", trigger: "blur" },
        ],
        // intForwarderConfigIdList: [
        //   { required: true, message: "请选择物流", trigger: "blur" },
        // ],
        deliveryTaskLimit: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else if (isNaN(value)) {
                callback(new Error("请输入数字"));
              } else if (value > 9999 || value < 1) {
                callback(new Error("发货单上限范围1~9999"));
              } else if (!Number.isInteger(Number(value))) {
                callback(new Error("请输入整数"));
              } else {
                callback();
              }
            },
          },
        ],
        pickTaskDeliveryProductLimit: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else if (isNaN(value)) {
                callback(new Error("请输入数字"));
              } else if (value > 9999 || value < 1) {
                callback(new Error("发货单商品数量范围1~9999"));
              } else if (!Number.isInteger(Number(value))) {
                callback(new Error("请输入整数"));
              } else {
                callback();
              }
            },
            required: true,
          },
        ],
        customerId: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
              } else if (isNaN(value)) {
                callback(new Error("请输入数字"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      customerInfo: null,
      checkDeliveryNumData: null,
    };
  },
  watch: {
    "form.singleProduct": {
      handler: function (newVal) {
        if (newVal || newVal === 0) {
          this.form.intForwarderConfigIdList = [];
        }
      },
    },
  },
  methods: {
    open(form = "") {
      const defaultForm = {
        deliveryType: 2,
        singleProduct: 1,
        pickTaskLimit:
          this.$store.getters.getWareCode == "1772139957530296320" ? 16 : 20,
        pickTaskDeliveryProductLimit: 20,
        groupType: 0,
        tiktokGroup: 0,
        explosiveProductGroupMin: 10,
      };
      this.form = defaultForm;
      const today = new Date();
      today.setHours(16);
      today.setMinutes(0);
      today.setMilliseconds(0);
      today.setSeconds(0);
      this.$set(
        this.form,
        "conditionEndTime",
        moment(today).format("YYYY-MM-DD HH:mm:ss")
      );
      if (form) {
        this.form = form;
      }
      this.getForwarder(true);
      // this.form.conditionEndTime = moment(today).format('YYYY-MM-DD HH:mm:ss')
      // this.form.conditionEndTime = today
      this.dialogVisible = true;
      this.customerInfo = null;
      this.checkDeliveryNumData = null;
      setTimeout(() => {
        this.clearValid();
      }, 0);
    },
    searchCustomer() {
      if (isNaN(this.form.customerId)) {
        this.$message.warning("请输入数字");
        return;
      }
      waveDeliveryTaskAmount({
        customerId: this.form.customerId,
        deliveryType: this.form.deliveryType,
      }).then((res) => {
        if (res.code == 0) {
          if (res.data.deliveryTaskTotalAmount) {
            this.customerInfo = res.data;
            return;
          }
          this.$message.warning("无匹配发货单");
        }
      });
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {};
          Object.keys(this.form).map((v) => {
            if (this.form[v] || this.form[v] == 0) {
              params[v] = this.form[v];
            }
          });
          params.conditionDeliveryTaskCodes = (
            params.conditionDeliveryTaskCodes?.split(/\n/) ?? []
          ).filter((v) => v);
          params?.customerId && (params.customerId = Number(params.customerId));
          params?.conditionEndTime &&
            (params.conditionEndTime = moment(params.conditionEndTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ));
          params.singleProduct == 1 && delete params.pickTaskLimit;
          params?.deliveryTaskLimit &&
            (params.deliveryTaskLimit = Math.floor(params.deliveryTaskLimit));
          params?.pickTaskLimit &&
            (params.pickTaskLimit = Math.floor(params.pickTaskLimit));
          params?.pickTaskDeliveryProductLimit &&
            (params.pickTaskDeliveryProductLimit = Number(
              params.pickTaskDeliveryProductLimit
            ));
          if (params.groupType === 0) {
            delete params.explosiveProductGroupMin;
          }
          if (
            this.form.groupType === 1 &&
            !this.form.explosiveProductGroupMin
          ) {
            this.$message.warning("请填写分组最小发货单数量");
            return;
          }
          if (!this.isHzOrXz || params.groupType === 0) {
            delete params.groupType;
            delete params.explosiveProductGroupMin;
          }
          waveCreate({ ...params }).then((res) => {
            if (res.code !== 0) {
              return;
            }
            this.$message.success("新建成功");
            this.dialogVisible = false;
            this.$emit("refresh");
          });
        }
      });
    },
    clearValid() {
      console.log("clearValid");
      this.$refs.form.clearValidate();
    },
    getForwarder(e) {
      if (!e) {
        return;
      }
      if (!this.form.deliveryType || this.form.deliveryType === 0) {
        this.$message.warning("请先选择发货类型");
        this.$refs.forwarderRef.blur();
        return;
      }
      waveForwarder({
        deliveryType: this.form.deliveryType,
        singleProduct: this.form.singleProduct,
      }).then((res) => {
        if (res.code == 0) {
          this.forwarder = res.data.sort((v1, v2) => {
            return (v2.totalAmount || 0) - (v1.totalAmount || 0);
          });
        }
      });
    },
    checkDeliveryNum() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {};
          Object.keys(this.form).map((v) => {
            if (this.form[v] || this.form[v] == 0) {
              params[v] = this.form[v];
            }
          });
          console.log();
          params.conditionDeliveryTaskCodes = (
            params.conditionDeliveryTaskCodes?.split(/\n/) ?? []
          ).filter((v) => v);
          params?.customerId && (params.customerId = Number(params.customerId));
          params?.conditionEndTime &&
            (params.conditionEndTime = moment(params.conditionEndTime).format(
              "YYYY-MM-DD HH:mm:ss"
            ));
          params.singleProduct == 1 && delete params.pickTaskLimit;
          params?.deliveryTaskLimit &&
            (params.deliveryTaskLimit = Math.floor(params.deliveryTaskLimit));
          params?.pickTaskLimit &&
            (params.pickTaskLimit = Math.floor(params.pickTaskLimit));
          if (!this.isHzOrXz || params.groupType === 0) {
            delete params.groupType;
            delete params.explosiveProductGroupMin;
          }
          waveMatchAnalysis({ ...params }).then((res) => {
            if (res.code !== 0) {
              return;
            }
            this.checkDeliveryNumData = res.data;
          });
        }
      });
    },
    toCancelWave() {
      waveCancel({
        waveCode: this.form.waveCode,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("撤回成功");
          this.dialogVisible = false;
          this.$emit("refresh");
        }
      });
    },
  },
  computed: {
    isHzOrXz: function () {
      const name = this.$store.getters.getWarehouses?.filter(
        (item) => item.wareCode == this.$store.getters.getWareCode
      )[0].wareName;
      return name === "杭州仓" || name === "西子仓" || name === "广州仓";
    },
  },
};
</script>
<style scoped>
::v-deep .el-form-item__content {
  text-align: left;
}

::v-deep .el-input {
  width: 200px;
}

::v-deep .waveform .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #fff !important;
  background-color: #409eff !important;
  border-color: #409eff !important;
  box-shadow: -1px 0 0 0 #409eff !important;
}
</style>
